import { Component } from '@angular/core';

@Component({
    selector: 'app-blank',
    imports: [],
    templateUrl: './blank.component.html'
})
export class BlankComponent {

}
